import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./Detail'))

//	///////////////////////
//	MARK: EXPORTS
/**
 * ★ Les réunions du SMS — `03` §3.7. Préfixe statique pour la fiche : un segment statique bat
 * toujours `:param` (`01` §15.2), et les onglets de la fiche prennent le reste.
 */
export const SafetyMeetingRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--safety--meetings']}>
    <Route path='meeting/:meetingId/*' element={<Detail />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
